import { useQuery } from '@tanstack/react-query';
import { supportApi } from '../services/supportApi';
import { ticketsKeys } from './queryKeys';

export const useMyTickets = () => {
  return useQuery({
    queryKey: ticketsKeys.mine(),
    queryFn: supportApi.listMyTickets,
    staleTime: 60_000,
    refetchInterval: 120_000,
  });
};
